import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ListUsersLoggedUser,
  LogedUser,
} from '../../models/logged-user.model';
import { UserSessionService } from '../../../services/user-session.service';
import { AuthSession } from '../auth-session';
import { AgencyModulesService } from './agency-modules.service';
import { mapListUserToLoggedUser } from './logged-user.mapper';
import { NewLoginService } from './new-login.service';

@Injectable()
export class NewAuthSessionService implements AuthSession {
  constructor(
    private readonly userSessionService: UserSessionService,
    private readonly agencyModulesService: AgencyModulesService,
    private readonly loginService: NewLoginService,
    private readonly router: Router,
  ) {}

  getStoredLoggedUser(): LogedUser | null {
    const raw = localStorage.getItem(UserSessionService.LOGGED_USER);
    if (!raw) {
      return null;
    }
    try {
      const parsed = JSON.parse(raw) as LogedUser;
      return parsed?.secret ? parsed : null;
    } catch {
      return null;
    }
  }

  async restoreSession(): Promise<LogedUser> {
    const stored = this.getStoredLoggedUser();
    if (!stored) {
      throw new Error('No active session');
    }
    this.userSessionService.loggedUser = stored;
    return stored;
  }

  async switchOffice(user: ListUsersLoggedUser): Promise<void> {
    const current = this.getStoredLoggedUser();
    if (!current?.secret) {
      throw new Error('No active session');
    }
    const agencyModules = await this.agencyModulesService.getModuleIds(
      user.agencyId,
      current.secret,
    );
    const loggedUser = mapListUserToLoggedUser(
      user,
      current.secret,
      agencyModules,
    );
    loggedUser.listUsers = current.listUsers;
    this.userSessionService.loggedUser = loggedUser;
  }

  logout(): void {
    void this.loginService
      .logout()
      .catch((error) => {
        console.error('No se pudo cerrar la sesión en el servidor', error);
      })
      .finally(() => {
        void this.router.navigate(['/login'], {
          queryParams: { logout: true },
          replaceUrl: true,
        });
      });
  }
}
